import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import countryDescriptions from "../../data/countriesDescriptions.json";
import "./CountryPage.css";

function CountryPage() {
  const { countryName } = useParams();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const countryData = countryDescriptions[countryName.toLowerCase()];
  const name = countryData?.[currentLanguage]?.name || "No name available";
  const description =
    countryData?.[currentLanguage]?.description || "No description available";

  return (
    <main className="country-page">
      <section className="country-hero animate-fade-in">
        <h1 className="country-name">
          <Trans
            i18nKey={name}
            components={{ strong: <strong /> }}
          />
        </h1>
      </section>
      <section className="country-description animate-fade-in">
        <p>
          <Trans
            i18nKey={description}
            components={{ strong: <strong />, br: <br /> }}
          />
        </p>
      </section>
    </main>
  );
}

export default CountryPage;
